import { Box, Card, Typography, IconButton } from "@mui/material";
import CustomTable from "../../components/ui/CustomTable";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useIntl } from "react-intl";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Link } from "react-router-dom";
import axios from "../../api/axiosClient";
import { toast } from "react-hot-toast";
import { handleError, errorToast } from "../../services/serviceBase";
import { useLoading } from "../../components/LoadingContext";

export default function Controlled(props) {
  const intl = useIntl();
  const { setLoading } = useLoading();

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      {...props}
      sx={{ ".MuiAccordionSummary-content": { margin: 0.5 } }}
    />
  ))(({ theme }) => ({
    border: `1px solid white`,
  }));

  const handleDeleteQCCarton = (boxBarcode) => {
    var message = intl.formatMessage({ id: "QC.ConfirmBoxDeletion" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    axios
      .delete("/qualitycheck/boxes/" + boxBarcode)
      .then((response) => {
        setLoading(false);
        props.reloadFunction();
        toast.success("Deleted!");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Box>
      <Card>
        <Card
          sx={{ mt: 1, height: `${props.tableHeigth}px`, overflow: "auto" }}
        >
          {props.groupedDetailsRows.map((outcome) => {
            var currentOutcome = props.outcomes.find(
              (x) => x.idAnagQCOutcome === outcome.idAnagQCOutcome
            );
            return (
              <Accordion
                key={`${outcome.idAnagQCOutcome}`}
                defaultExpanded={true}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className="apeRaDetailOutcomeBackground"
                >
                  <Typography variant="subtitle1" sx={{ ml: 1 }}>
                    {intl.formatMessage({ id: "General.Outcome" })}:{" "}
                    <strong>
                      {currentOutcome?.buttonLabel !=
                      currentOutcome?.outcomeDescription
                        ? currentOutcome?.buttonLabel
                        : currentOutcome?.outcomeDescription}
                    </strong>
                  </Typography>
                </AccordionSummary>
                {outcome.boxes.map((box) => {
                  var sum = 0;
                  for (let i = 0; i < box.items.length; i++) {
                    sum += box.items[i].renderedQty;
                  }

                  var height = 25 + 75 * box.items.length;
                  return (
                    <Accordion key={`${box.boxBarcode}`} defaultExpanded={true}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={
                          box.isExtra
                            ? "apeRaDetailsBoxBackgroundExtraQty"
                            : "apeRaDetailsBoxBackground"
                        }
                      >
                        <Typography variant="subtitle1" sx={{ ml: 1 }}>
                          {intl.formatMessage({ id: "General.BoxBarcode" })}:{" "}
                          <strong>{box.boxBarcode}</strong> -{" "}
                          {intl.formatMessage({ id: "General.Peces" })}:{" "}
                          <strong>{sum}</strong>
                          <IconButton
                            size="large"
                            color="black"
                            onClick={(e) => handleDeleteQCCarton(box.boxBarcode)}
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                bgcolor: "transparent",
                              },
                              "&.MuiButtonBase-root": {
                                color: "black",
                              },
                            }}
                          >
                            {" "}
                            <DeleteForeverIcon />
                          </IconButton>
                        </Typography>
                      </AccordionSummary>
                      <CustomTable
                        key={`${box.boxBarcode}${outcome.idAnagQCOutcome}`}
                        columns={props.detailsColumns}
                        rows={box.items}
                        id={"rowNumber"}
                        rowHeight={40}
                        headerHeight={30}
                        tableHeight={height}
                      />
                    </Accordion>
                  );
                })}
              </Accordion>
            );
          })}
        </Card>
      </Card>
    </Box>
  );
}
